"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_66_4_0 = void 0;
/**
 * Migrate to 66.4.0
 *
 * delete ChangedInManualMode
 */
const migration_66_4_0 = (json) => {
    if ('ChangedInManualMode' in json) {
        delete json.ChangedInManualMode;
    }
    return json;
};
exports.migration_66_4_0 = migration_66_4_0;
//# sourceMappingURL=migration_66_4_0.js.map